import { DocumentFilter } from "@/lib/redux/documentFilters/documentFiltersSlice";
import { useAppSelector } from "@/lib/redux/hooks";
import { jobsFilterSelectors } from "@/lib/redux/store";
import React, { useState } from "react";
import SelectorComponent from "./Selector";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Selector = SelectorComponent as any;

const Facets: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<null | DocumentFilter>();
  const filters = useAppSelector(jobsFilterSelectors.selectAll);

  return (
    <Container>
      {filters.map((filter) => (
        <Selector
          key={filter.id}
          filter={filter}
          isOpen={filter.id === activeFilter?.id}
          handleOpen={() => setActiveFilter(filter)}
          handleClose={() => setActiveFilter(null)}
        />
      ))}
    </Container>
  );
};

export default Facets;
